<template>
  <div class="position-manager">
    <div class="position-header">
      <el-button 
        size="small" 
        type="primary" 
        icon="el-icon-plus"
        @click="addPosition"
      >
        添加岗位
      </el-button>
    </div>
    
    <el-table
      size="small"
      :data="positionList"
      border
      style="width: 100%"
      v-loading="loading"
    >
      <el-table-column prop="name" label="岗位名称" width="150"></el-table-column>
      <el-table-column prop="code" label="岗位编码" width="120"></el-table-column>
      <el-table-column prop="description" label="岗位描述"></el-table-column>
      <el-table-column prop="sort" label="排序" width="80" align="center">
        <template slot-scope="scope">
          <el-input-number 
            v-model="scope.row.sort" 
            size="mini" 
            controls-position="right" 
            :min="0" 
            :max="999"
            @change="handleSortChange(scope.row)"
          ></el-input-number>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="80" align="center">
        <template slot-scope="scope">
          <el-tag 
            :type="scope.row.status === 1 ? 'success' : 'info'"
            size="small"
          >
            {{ scope.row.status === 1 ? '启用' : '停用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="150" align="center">
        <template slot-scope="scope">
          <el-button 
            @click="editPosition(scope.row)" 
            type="text" 
            size="small"
            icon="el-icon-edit"
          >编辑</el-button>
          <el-button 
            @click="deletePosition(scope.row)" 
            type="text" 
            size="small"
            icon="el-icon-delete"
            style="color: #f56c6c;"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 添加/编辑岗位对话框 -->
    <el-dialog
      :title="positionDialogTitle"
      :visible.sync="positionDialogVisible"
      width="500px"
      @close="handlePositionDialogClose"
    >
      <el-form 
        ref="positionFormRef" 
        :model="positionForm" 
        :rules="positionRules" 
        label-width="80px"
        size="small"
      >
        <el-form-item label="岗位名称" prop="name">
          <el-input 
            v-model="positionForm.name" 
            placeholder="请输入岗位名称"
            maxlength="50"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="岗位编码" prop="code">
          <el-input 
            v-model="positionForm.code" 
            placeholder="请输入岗位编码"
            maxlength="20"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="岗位描述" prop="description">
          <el-input 
            v-model="positionForm.description" 
            type="textarea"
            :rows="3"
            placeholder="请输入岗位描述"
            maxlength="200"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="排序" prop="sort">
          <el-input-number 
            v-model="positionForm.sort" 
            controls-position="right" 
            :min="0" 
            :max="999"
            style="width: 120px;"
          ></el-input-number>
        </el-form-item>
        
        <el-form-item label="状态" prop="status">
          <el-switch
            v-model="positionForm.status"
            :active-value="1"
            :inactive-value="0"
            active-text="启用"
            inactive-text="停用"
          ></el-switch>
        </el-form-item>
      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="positionDialogVisible = false" size="small">取 消</el-button>
        <el-button 
          type="primary" 
          @click="handlePositionSubmit" 
          size="small"
          :loading="positionSubmitLoading"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Ma_positionApi from '@/api/ma_position.js';

export default {
  name: 'PositionManager',
  props: {
    departmentId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      loading: false,
      positionList: [],
      
      positionDialogVisible: false,
      positionDialogTitle: '添加岗位',
      positionSubmitLoading: false,
      
      positionForm: {
        ma_position_id: '',
        ma_depart_id: '',
        name: '',
        code: '',
        description: '',
        sort: 100,
        status: 1
      },
      
      positionRules: {
        name: [
          { required: true, message: '请输入岗位名称', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入岗位编码', trigger: 'blur' }
        ]
      }
    };
  },
  watch: {
    departmentId: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.loadPositions();
        }
      }
    }
  },
  methods: {
    // 加载岗位数据
    loadPositions() {
      this.loading = true;
      
      Ma_positionApi.list({
        ma_depart_id: this.departmentId,
        page: 1,
        list_rows: 100
      }, true)
      .then(data => {
        this.loading = false;
        if (data.code === 1) {
          this.positionList = data.data.list.data || [];
        } else {
          this.$message.error(data.msg || '获取岗位列表失败');
        }
      })
      .catch(error => {
        this.loading = false;
        console.error('获取岗位列表失败:', error);
        this.$message.error('获取岗位列表失败');
      });
    },
    
    // 添加岗位
    addPosition() {
      this.positionDialogTitle = '添加岗位';
      this.resetPositionForm();
      this.positionForm.ma_depart_id = this.departmentId;
      this.positionDialogVisible = true;
    },
    
    // 编辑岗位
    editPosition(row) {
      this.positionDialogTitle = '编辑岗位';
      
      // 获取岗位详情
      this.loading = true;
      Ma_positionApi.detail({ ma_position_id: row.ma_position_id }, true)
        .then(data => {
          this.loading = false;
          if (data.code === 1) {
            this.positionForm = {
              ma_position_id: data.data.ma_position_id,
              ma_depart_id: data.data.ma_depart_id || this.departmentId,
              name: data.data.name || '',
              code: data.data.code || '',
              description: data.data.description || '',
              sort: data.data.sort || 100,
              status: data.data.status || 1
            };
            this.positionDialogVisible = true;
          } else {
            this.$message.error(data.msg || '获取岗位详情失败');
          }
        })
        .catch(error => {
          this.loading = false;
          console.error('获取岗位详情失败:', error);
          this.$message.error('获取岗位详情失败');
        });
    },
    
    // 删除岗位
    deletePosition(row) {
      this.$confirm('确定要删除该岗位吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        Ma_positionApi.del({ ma_position_id: row.ma_position_id }, true)
          .then(data => {
            this.loading = false;
            if (data.code === 1) {
              this.$message.success('删除成功');
              this.loadPositions();
            } else {
              this.$message.error(data.msg || '删除失败');
            }
          })
          .catch(error => {
            this.loading = false;
            console.error('删除失败:', error);
            this.$message.error('删除失败');
          });
      }).catch(() => {});
    },
    
    // 处理排序改变
    handleSortChange(row) {
      Ma_positionApi.edit({
        ma_position_id: row.ma_position_id,
        sort: row.sort
      }, true)
        .then(data => {
          if (data.code === 1) {
            this.$message.success('排序更新成功');
          } else {
            this.$message.error(data.msg || '更新失败');
          }
        })
        .catch(error => {
          console.error('更新排序失败:', error);
          this.loadPositions(); // 重新加载恢复原排序
        });
    },
    
    // 重置岗位表单
    resetPositionForm() {
      this.positionForm = {
        ma_position_id: '',
        ma_depart_id: this.departmentId,
        name: '',
        code: '',
        description: '',
        sort: 100,
        status: 1
      };
      
      if (this.$refs.positionFormRef) {
        this.$refs.positionFormRef.clearValidate();
      }
    },
    
    // 对话框关闭处理
    handlePositionDialogClose() {
      this.resetPositionForm();
    },
    
    // 提交岗位表单
    handlePositionSubmit() {
      this.$refs.positionFormRef.validate(valid => {
        if (valid) {
          this.positionSubmitLoading = true;
          
          const api = this.positionForm.ma_position_id 
            ? Ma_positionApi.edit 
            : Ma_positionApi.add;
            
          const params = { ...this.positionForm };
          
          api(params, true)
            .then(data => {
              this.positionSubmitLoading = false;
              if (data.code === 1) {
                this.positionDialogVisible = false;
                this.$message.success(
                  this.positionForm.ma_position_id ? '修改成功' : '添加成功'
                );
                this.loadPositions();
              } else {
                this.$message.error(data.msg || '操作失败');
              }
            })
            .catch(error => {
              this.positionSubmitLoading = false;
              console.error('操作失败:', error);
              this.$message.error('操作失败');
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.position-manager {
  .position-header {
    margin-bottom: 20px;
  }
  
  .el-table {
    margin-bottom: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/ma_depart/index/part/PositionManager.vue